/**
 * Darwin AI chat types
 */

export enum ChatMessageRole {
    USER = "user",
    ASSISTANT = "assistant",
}

export enum ChatMessageRating {
    UP = "up",
    DOWN = "down",
}

export type ChatToolRequest = {
    summary: string;
    incidentId?: string;
};

export type ChatMessage = {
    id: string;
    role: ChatMessageRole;
    content: string;
    createdAt?: string;
    rating?: ChatMessageRating;
    /** Set when Darwin cannot do what was asked and the user can request that capability. */
    toolRequest?: ChatToolRequest;
};

export type DarwinPageContext = {
    path: string;
    title?: string;
    search?: Record<string, unknown>;
    timezone?: string;
};

/** An Elitphone page Darwin may link to. `$name` path segments are path params. */
export type DarwinPage = {
    path: string;
    title?: string;
    /** Allowed query params, e.g. "tab: transcript|details|evaluation" */
    query?: string;
};

export type DarwinChatRequest = {
    /** Omitted on the first message; the server starts a conversation and streams back its id. */
    conversationId?: string;
    message: Pick<ChatMessage, "id" | "content">;
    replyMessageId: string;
    page: DarwinPageContext;
    pages: DarwinPage[];
};

// Matches the elitai-svc Darwin stream events
export type StreamEventData = {
    type: "conversation" | "token" | "tool" | "tool_request" | "done" | "error";
    data: string;
    timestamp: number;
};
